import { Link } from "react-router-dom";

const BG_COLORS = ["#FFD500", "#FF2E93", "#00E5FF", "#39FF14"];

export default function ProductCard({ product, idx = 0 }) {
  const bg = BG_COLORS[idx % BG_COLORS.length];
  return (
    <Link
      to={`/product/${product.id}`}
      className="pw-card p-4 block group"
      data-testid={`product-card-${product.id}`}
    >
      <div
        className="relative rounded-xl border-3 border-black overflow-hidden mb-4 aspect-square"
        style={{ background: bg, borderWidth: 3 }}
      >
        <img
          src={product.image}
          alt={product.name}
          className="w-full h-full object-cover mix-blend-multiply group-hover:scale-105 transition-transform duration-300"
          loading="lazy"
        />
        {product.badge && (
          <span
            className={`pw-badge ${
              product.badge === "SALE" ? "pink" : product.badge === "NEW" ? "green" : "yellow"
            } absolute top-3 left-3`}
          >
            {product.badge}
          </span>
        )}
      </div>
      <div className="flex items-start justify-between gap-3">
        <h3 className="font-display text-lg leading-tight">{product.name}</h3>
        <span
          className="font-display text-lg whitespace-nowrap bg-[#FFFDF0] border-2 border-black px-2 py-0.5 rounded-md"
          data-testid={`product-price-${product.id}`}
        >
          ${product.price.toFixed(2)}
        </span>
      </div>
      <p className="text-xs opacity-70 mt-1 uppercase tracking-wider font-bold">
        {product.category}
      </p>
    </Link>
  );
}
